module.exports = {"id":"225508","name":"Eric Bailly","rating":"84","photo":"./data/images/photos/0/225508.png","club":{"name":"Manchester Utd","logo":"./data/images/clubs/ManchesterUtd.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EricBailly0.json
// module id = 1268
// module chunks = 0